import React from "react";

export const PolicyInforcedHeader = (props) => {
    return (
        <>
            <thead className={"bp-report-thead"}>
            <tr className={"bp-report-thead-tr"}>
                <th rowSpan={3} className={"bp-report-thead-th"}>Cây báo cáo</th>
                <th colSpan={2} className={"bp-report-thead-th"}>Ngày { props?.inputDay }</th>
            </tr>
            <tr className={"bp-report-thead-tr"}>
                <th colSpan={2}>Hợp đồng bảo hiểm còn hiệu lực</th>
            </tr>
            <tr className={"bp-report-thead-tr"}>
                <th>Số lượng Hợp đồng</th>
                <th>IP</th>
            </tr>
            </thead>
        </>
    )
}

export default  PolicyInforcedHeader;